var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{on:{"tab-click":_vm.gotoOtherPage},model:{value:(_vm.tabsName),callback:function ($$v) {_vm.tabsName=$$v},expression:"tabsName"}},_vm._l((_vm.list),function(item,index){return _c('el-tab-pane',{key:index,attrs:{"label":item.name,"name":item.name}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }